import { type Color } from "./Text";

/**
 * État d'une étape d'onboarding ou d'une mission de checklist : `active` est
 * celle à traiter maintenant, `pending` celles qui viendront après.
 */
export type StepStatus = "done" | "active" | "pending";

/** Couleur de la pastille numérotée (`StepBadge`) selon l'état. */
export const STEP_BADGE_COLORS: Record<StepStatus, Color> = {
  done: "success",
  active: "primary",
  pending: "neutral",
};

/** Couleur du titre d'une étape selon son état. */
export const STEP_TITLE_COLORS: Record<StepStatus, Color> = {
  done: "success",
  active: "primary",
  pending: "neutral",
};

/** Couleur de la description d'une étape selon son état. */
export const STEP_DESC_COLORS: Record<StepStatus, Color> = {
  done: "success",
  active: "muted",
  pending: "muted",
};
